export enum CoOwnerInputLabel {
  FirstName = 'Non-Borrowing Co-Owner First Name',
  LastName = 'Non-Borrowing Co-Owner Last Name',
  Address = 'Address',
  City = 'City',
  State = 'State',
  Zip = 'Zip Code',
  Email = 'Non-Borrowing Co-Owner Email',
  PhoneNumber = 'Non-Borrowing Co-Owner Cell Phone',
  DateOfBirth = 'Non-Borrowing Co-Owner Date Of Birth',
  Ssn = 'Non-Borrowing Co-Owner SSN',
}

export enum CoOwnerInputName {
  FirstName = 'firstName',
  LastName = 'lastName',
  Address = 'address',
  City = 'city',
  State = 'state',
  Zip = 'zip',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  DateOfBirth = 'dateOfBirth',
  Ssn = 'ssn',
}
